export const IconArrowMenu = () => {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ minWidth: 12, minHeight: 12, maxWidth: 12, maxHeight: 12 }}
    >
      <path
        d="M1.25 1.5L4.75 5L1.25 8.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
